import React from 'react'
import { useParams } from "react-router-dom";
import ZastupiteleDetail from './ZastupiteleDetail';

const ZastupiteleWrapper = ({baseUrl, apiBaseUrl}) => {  
    let params = useParams();
    return <ZastupiteleDetail id={ params.zastupitelId } baseUrl={ baseUrl } apiBaseUrl={ apiBaseUrl } />
};

export default ZastupiteleWrapper
